import React, { useEffect, useState } from 'react';
import { IoClose } from 'react-icons/io5';

const Notification = ({ message, onClose }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const animationDelayTimer = setTimeout(() => {
      setVisible(true);
    }, 200); // Delay animation by 1 second

    const autoHideTimer = setTimeout(() => {
      setVisible(false);
    }, 4000); // Auto-hide after 3 seconds of being visible (1s delay + 3s visibility)

    return () => {
      clearTimeout(animationDelayTimer);
      clearTimeout(autoHideTimer);
    };
  }, []);

  const handleClose = () => {
    setVisible(false);
    onClose && onClose(); // Call the onClose callback if provided
  };

  if (!visible) return null;

  return (
    <div className={`fixed bottom-4   right-4 z-50 transition-transform duration-300 transform ${visible ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0'}  `}>
      <div className="bg-white backdrop-blur-sm  bg-opacity-30 dark:bg-opacity-30 dark:bg-gray-800 text-black dark:text-white border border-gray-300 dark:border-gray-700 rounded-lg shadow-lg p-4 flex items-center">
        <p className="flex-1">{message}</p>
        <button onClick={handleClose} className="ml-4 text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300">
          <IoClose className="h-6 w-6" />
        </button>
      </div>
    </div>
  );
};

export default Notification;
